import { cn } from 'helpers/classnames';
import useMartyContext from 'hooks/useMartyContext';
import ReturnPackagelessTooltip from 'components/account/Returns/ReturnPackagelessTooltip';
import StoreIcon from 'images/zappos/packageless-method.svg';
import ReturnInstructionsSection from 'components/account/Returns/ReturnInstructionsSection';
import { PROVIDE_LABEL_OPTIONS } from 'constants/exchanges';
import ReturnLabelOption from 'components/account/Returns/ReturnLabelOption';
import External from 'images/zappos/external.svg';
import { UPS_FIND_STORE_URL } from 'constants/appConstants';

// eslint-disable-next-line css-modules/no-unused-class
import css from 'styles/containers/returns/returnLabelOption.scss';

const UPSPackagelessOption = ({
  labelDelivery,
  customerInfo,
  onReturnMethodSelect,
  showInstructions,
  showInstructionsHandler,
  showPackagelessReturn,
  displayOnly,
  className
}) => {
  const {
    marketplace: { dataMaskPiiElements }
  } = useMartyContext();

  if (!showPackagelessReturn) {
    return null;
  }

  const expandedInfo = (
    <div className={css.additionalInfo}>
      {customerInfo?.email && (
        <p className={cn(css.infoTitle, 'zappos:body-m')} data-cs-mask={dataMaskPiiElements}>
          Return code will be sent to: <span className={css.additionalInfoContent}>{customerInfo.email}</span>
        </p>
      )}
    </div>
  );

  const checked = labelDelivery === PROVIDE_LABEL_OPTIONS.UPS_PACKAGELESS;

  const extraInfo = (
    <div className={cn(css.extraInfo, 'zappos:body-m')}>
      *Participating UPS locations include The UPS Store only. It does not include UPS Access Point™, UPS Customer Centre, UPS Drop Box, Retail
      Chains, Authorized Shipping Outlet, and UPS Authorized Service Providers.
    </div>
  );

  const returnInstructionsSection = (
    <ReturnInstructionsSection
      checked={checked}
      displayOnly={displayOnly}
      extraInfo={extraInfo}
      showInstructions={showInstructions}
      showInstructionsHandler={showInstructionsHandler}
      value={PROVIDE_LABEL_OPTIONS.UPS_PACKAGELESS}
      storeIcon={StoreIcon}
    />
  );
  const optionInformation = (
    <>
      <b>
        Without shipping box and label <ReturnPackagelessTooltip />
      </b>
      <p className={cn(css.optionInfo, { [css.checkedOptionInfo]: checked })}>
        Show your return code at <b>participating</b>{' '}
        <a href={UPS_FIND_STORE_URL} target="_blank" rel="noopener noreferrer">
          The UPS Store*
          <img className="ml-1 inline-block" src={External} alt="external" />
        </a>{' '}
        locations and we will take care of the rest.
      </p>
      {checked && !displayOnly && expandedInfo}
    </>
  );
  const labelButtonsGroup = (
    <div className={css.labelButtonsWrapper}>
      <a href={UPS_FIND_STORE_URL} target="_blank" rel="noopener noreferrer" className={css.externalLink}>
        Find Participating UPS Stores <img className="ml-1 inline-block" src={External} alt={'external'} />
      </a>
    </div>
  );

  return (
    <ReturnLabelOption
      data-test-id="return-label-option"
      badge="Recommended"
      checked={checked}
      children={returnInstructionsSection}
      icon={StoreIcon}
      id={PROVIDE_LABEL_OPTIONS.UPS_PACKAGELESS}
      optionTitle="Drop-off"
      optionInformation={optionInformation}
      onReturnMethodSelect={onReturnMethodSelect}
      showInstructions={showInstructions}
      showInstructionsHandler={showInstructionsHandler}
      value={PROVIDE_LABEL_OPTIONS.UPS_PACKAGELESS}
      displayOnly={displayOnly}
      labelButtonsGroup={labelButtonsGroup}
      className={className}
    />
  );
};
export default UPSPackagelessOption;
